'use client';

import { IoCompassOutline } from 'react-icons/io5';

import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { CompanyProfile, File } from 'models';
import { RouterHelpers } from 'helpers/RouterHelpers';

import { ProfileRow, ProfileRowCarousel } from 'components/company-profile/components/ProfileRow';
import { IKImage } from 'components/ik-image/IKImage';
import { Section } from 'components/section/Section';
import { useIndustryCategories } from 'hooks/use-industry-categories';

const RelatedCategories = ({ company }: { company: CompanyProfile }) => {
    const { subCategories } = useIndustryCategories();

    const relatedSubcategories = subCategories.filter((sub) =>
        CollectionHelpers.contains(company.industrySubcategories, sub),
    );

    if (!relatedSubcategories.length) {
        return null;
    }

    return (
        <Section title="Explore More">
            <ProfileRowCarousel>
                {relatedSubcategories.map((subcategory) => (
                    <ProfileRow
                        key={subcategory.id}
                        leadingShape={subcategory.image ? 'thumbnail' : 'round'}
                        leading={
                            subcategory.image ? (
                                <IKImage
                                    fileOrId={subcategory.image as File | string}
                                    width={80}
                                    alt={subcategory.name || ''}
                                />
                            ) : (
                                <IoCompassOutline />
                            )
                        }
                        title={subcategory.name}
                        meta={subcategory.description || 'Browse companies in this category'}
                        href={RouterHelpers.urls.profiles.categories(subcategory.slug!)}
                    />
                ))}
            </ProfileRowCarousel>
        </Section>
    );
};

export { RelatedCategories };
